import { useEffect, lazy, Suspense } from 'react';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Box } from '@mui/material';
import { Container } from '~/content/components/Container';
// import ContactCard from './contactCard';
// import Content from './content';
const Content = lazy(() => import('./content.tsx'));
const ContactCard = lazy(() => import('./contactCard.tsx'));

import { trackPageview } from '~/utils/plausible';
import { useTranslation } from 'react-i18next';

const Legal = (): JSX.Element => {
	const theme = useTheme();
	let { t } = useTranslation(['legal']);

	useEffect(() => {
		trackPageview();
	}, []);
	return (
		<Container>
			<Box boxShadow={0} borderRadius={0} bgcolor={theme.palette.background.level2}>
				<Box bgcolor={theme.palette.secondary.light} borderRadius={0}>
					<Container paddingX={{ xs: 2, sm: 4 }}>
						<Typography
							component={'h1'}
							variant={'h4'}
							gutterBottom
							sx={{
								fontWeight: 700,
								color: theme.palette.background.default,
							}}
						>
							{t('headline')}
						</Typography>
						<Typography
							gutterBottom
							sx={{
								color: theme.palette.background.default,
							}}
						>
							{t('headlineCaption', { context: '1' })}{' '}
							<strong> {t('headlineCaption', { context: '2' })}</strong>
						</Typography>
					</Container>

					{/* <Box
							component={'svg'}
							preserveAspectRatio="none"
							xmlns="http://www.w3.org/2000/svg"
							x="0px"
							y="0px"
							viewBox="0 0 1920 100.1"
							width={1}
							marginBottom={-10}
						>
							<path
                fill={theme.palette.background.paper}
                d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
              ></path>
						</Box> */}
				</Box>
				<Container
					paddingTop={'100 !important'}
					paddingX={{ xs: 2, sm: 4 }}
					position={'relative'}
					top={0}
				>
					<Box
						component={Grid}
						container
						spacing={4}
						flexDirection={{ xs: 'column-reverse', md: 'row' }}
					>
						<Grid item xs={12} md={9}>
							<Content />
						</Grid>
						<Grid item xs={12} md={3}>
							<Box position={'sticky'} top={theme.spacing(20)} className={'sticky'}>
								<ContactCard />
							</Box>
						</Grid>
					</Box>
				</Container>
			</Box>
		</Container>
	);
};

export default Legal;
